"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RWSToolsDetectTasksDataComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const types_1 = require("../../types");
//@ts-ignore                
let rwsTemplate = T.html `<div class="rws-tools-detect-tasks-data">
    ${(0, fast_element_1.when)(x => { var _a, _b; return ((_b = (_a = x.tasksData) === null || _a === void 0 ? void 0 : _a.tasks) === null || _b === void 0 ? void 0 : _b.length) > 0; }, (0, fast_element_1.html) `
        <div class="tasks-container">
            ${(0, fast_element_1.repeat)(x => x.tasksData.tasks, (0, fast_element_1.html) `
                <div class="task-item ${task => task.done ? 'done' : ''}">
                    <div class="task-header">
                        <span class="task-status-icon">${task => task.done ? '✅' : '⬜'}</span>
                        <span class="task-title">${task => task.title}</span>
                    </div>
                    ${(0, fast_element_1.when)(task => { var _a; return ((_a = task.items) === null || _a === void 0 ? void 0 : _a.length) > 0; }, (0, fast_element_1.html) `
                        <div class="subtasks">
                            ${(0, fast_element_1.repeat)(task => task.items, (0, fast_element_1.html) `
                                <div class="subtask-item ${sub => sub.done ? 'done' : ''}">
                                    <span class="subtask-status">${sub => sub.done ? '✅' : '⬜'}</span>
                                    <span class="subtask-title">${sub => sub.title}</span>
                                </div>
                            `)}
                        </div>
                    `)}
                </div>
            `)}
        </div>
        ${(0, fast_element_1.when)(x => { var _a, _b; return ((_b = (_a = x.tasksData) === null || _a === void 0 ? void 0 : _a.notes) === null || _b === void 0 ? void 0 : _b.length) > 0; }, (0, fast_element_1.html) `
            <div class="task-notes">
                <div class="notes-label">${'detectTasks.notes'.t()}</div>
                ${(0, fast_element_1.repeat)(x => x.tasksData.notes, (0, fast_element_1.html) `
                    <p class="note-item">${note => note}</p>
                `)}
            </div>
        `)}
    `)}

    ${(0, fast_element_1.when)(x => { var _a, _b; return !((_b = (_a = x.tasksData) === null || _a === void 0 ? void 0 : _a.tasks) === null || _b === void 0 ? void 0 : _b.length); }, (0, fast_element_1.html) `
        <div class="empty-state">
            <span class="empty-icon">📋</span>
            <p>${'detectTasks.noTasks'.t()}</p>
        </div>
    `)}
</div>
`;
require("./styles/layout.scss");
const styles = T.css `@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.rws-tools-detect-tasks-data {
  border-radius: 12px;
}
.rws-tools-detect-tasks-data .tasks-container {
  background: var(--bg-secondary, #f8f9fa);
  border-radius: 8px;
  padding: 16px;
  display: grid;
  gap: 8px;
}
.rws-tools-detect-tasks-data .tasks-container .task-item {
  background: var(--bg-tertiary, #ffffff);
  border: 1px solid var(--border-color-light, #dee2e6);
  border-radius: 8px;
  padding: 12px 16px;
  color: var(--text-secondary, #6c757d);
  font-size: 0.9rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  transition: all 0.2s ease-in-out;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.rws-tools-detect-tasks-data .tasks-container .task-item:hover {
  transform: translateX(4px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-color: var(--primary-color, #007acc);
}
.rws-tools-detect-tasks-data .tasks-container .task-item:hover::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: var(--primary-color, #007acc);
}
.rws-tools-detect-tasks-data .tasks-container .task-item {
  flex-direction: column;
  align-items: stretch;
  cursor: default;
}
.rws-tools-detect-tasks-data .tasks-container .task-item.done {
  opacity: 0.7;
}
.rws-tools-detect-tasks-data .tasks-container .task-item.done .task-title {
  text-decoration: line-through;
}
.rws-tools-detect-tasks-data .tasks-container .task-item:hover {
  transform: none;
}
.rws-tools-detect-tasks-data .tasks-container .task-item .task-header {
  display: flex;
  align-items: center;
  gap: 8px;
}
.rws-tools-detect-tasks-data .tasks-container .task-item .task-header .task-status-icon {
  font-size: 1rem;
  flex-shrink: 0;
}
.rws-tools-detect-tasks-data .tasks-container .task-item .task-header .task-title {
  font-weight: 600;
  color: var(--text-primary, #1a1a1a);
  font-size: 0.95rem;
}
.rws-tools-detect-tasks-data .tasks-container .task-item .subtasks {
  margin-top: 8px;
  padding-left: 28px;
  display: grid;
  gap: 4px;
}
.rws-tools-detect-tasks-data .tasks-container .task-item .subtasks .subtask-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  color: var(--text-secondary, #6c757d);
}
.rws-tools-detect-tasks-data .tasks-container .task-item .subtasks .subtask-item.done {
  opacity: 0.7;
}
.rws-tools-detect-tasks-data .tasks-container .task-item .subtasks .subtask-item.done .subtask-title {
  text-decoration: line-through;
}
.rws-tools-detect-tasks-data .tasks-container .task-item .subtasks .subtask-item .subtask-status {
  font-size: 0.85rem;
  flex-shrink: 0;
}
.rws-tools-detect-tasks-data .task-notes {
  margin-top: 12px;
  padding: 12px;
  background: var(--bg-secondary, #f8f9fa);
  border-radius: 8px;
}
.rws-tools-detect-tasks-data .task-notes .notes-label {
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--text-primary, #1a1a1a);
  margin-bottom: 8px;
}
.rws-tools-detect-tasks-data .task-notes .note-item {
  margin: 4px 0;
  font-size: 0.85rem;
  color: var(--text-secondary, #6c757d);
}
.rws-tools-detect-tasks-data .empty-state {
  text-align: center;
  padding: 32px 16px;
  color: var(--text-secondary, #6c757d);
}
.rws-tools-detect-tasks-data .empty-state .empty-icon {
  font-size: 3rem;
  margin-bottom: 16px;
  display: block;
  opacity: 0.7;
}
.rws-tools-detect-tasks-data .empty-state p {
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
}
.rws-tools-detect-tasks-data .empty-state .empty-suggestion {
  color: var(--text-tertiary, #9ca3af);
  font-size: 0.9rem;
  font-style: italic;
  margin-top: 8px;
}
[data-theme=dark] .rws-tools-detect-tasks-data .tool-container {
  background: var(--bg-secondary-dark, #2d3748);
}
[data-theme=dark] .rws-tools-detect-tasks-data .tool-list-item {
  background: var(--bg-tertiary-dark, #374151);
  border-color: var(--border-color-light-dark, #4a5568);
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-detect-tasks-data .tool-list-item .item-title {
  color: var(--text-primary-dark, #f7fafc);
}
[data-theme=dark] .rws-tools-detect-tasks-data .tool-list-item .item-subtitle {
  color: var(--text-tertiary-dark, #718096);
}
[data-theme=dark] .rws-tools-detect-tasks-data .tool-list-item .item-description {
  color: var(--text-secondary-dark, #a0aec0);
  border-top-color: var(--border-color-light-dark, #4a5568);
}
[data-theme=dark] .rws-tools-detect-tasks-data .tool-list-item:hover {
  background: var(--bg-hover-dark, #4a5568);
  border-color: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-detect-tasks-data .tool-list-item:hover::after {
  background: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-detect-tasks-data .tool-query-display {
  background: var(--bg-secondary-dark, #2d3748);
  border-left-color: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-detect-tasks-data .tool-query-display .query-label {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-detect-tasks-data .tool-query-display .query-text {
  color: var(--text-primary-dark, #f7fafc);
  background: var(--bg-tertiary-dark, #374151);
  border-color: var(--border-color-light-dark, #4a5568);
}
[data-theme=dark] .rws-tools-detect-tasks-data .tool-results-summary {
  background: var(--success-color-dark-bg, #1e4d2b);
  border-color: var(--success-color-dark, #68d391);
}
[data-theme=dark] .rws-tools-detect-tasks-data .tool-results-summary .results-count {
  color: var(--success-color-dark, #68d391);
}
[data-theme=dark] .rws-tools-detect-tasks-data .tool-empty-state {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-detect-tasks-data .tool-empty-state p {
  color: var(--text-primary-dark, #f7fafc);
}
[data-theme=dark] .rws-tools-detect-tasks-data .tool-empty-state .empty-suggestion {
  color: var(--text-tertiary-dark, #718096);
}
[data-theme=dark] .rws-tools-detect-tasks-data .tool-loading-state {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-detect-tasks-data .tool-loading-state .spinner {
  border-color: var(--border-color-dark, #4a5568);
  border-top-color: var(--primary-color-dark, #63b3ed);
}
@media (max-width: 768px) {
  .rws-tools-detect-tasks-data {
    padding: 16px;
    margin: 12px 0;
  }
  .rws-tools-detect-tasks-data h3 {
    font-size: 1.1rem;
  }
  .rws-tools-detect-tasks-data h4 {
    font-size: 0.95rem;
  }
  .rws-tools-detect-tasks-data .tool-container {
    padding: 12px;
  }
  .rws-tools-detect-tasks-data .tool-list-item {
    padding: 10px 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .rws-tools-detect-tasks-data .tool-list-item .item-title {
    font-size: 0.9rem;
  }
  .rws-tools-detect-tasks-data .tool-list-item .item-description {
    font-size: 0.85rem;
  }
}
@media (max-width: 480px) {
  .rws-tools-detect-tasks-data .tool-empty-state {
    padding: 24px 12px;
  }
  .rws-tools-detect-tasks-data .tool-empty-state .empty-icon {
    font-size: 2rem;
  }
  .rws-tools-detect-tasks-data .tool-empty-state p {
    font-size: 0.9rem;
  }
}`;
const shadowOptions = { "mode": "open" };
let RWSToolsDetectTasksDataComponent = class RWSToolsDetectTasksDataComponent extends client_1.RWSViewComponent {
};
exports.RWSToolsDetectTasksDataComponent = RWSToolsDetectTasksDataComponent;
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof types_1.DetectTasksData !== "undefined" && types_1.DetectTasksData) === "function" ? _a : Object)
], RWSToolsDetectTasksDataComponent.prototype, "tasksData", void 0);
exports.RWSToolsDetectTasksDataComponent = RWSToolsDetectTasksDataComponent = __decorate([
    (0, client_1.RWSView)('rws-tools-detect-tasks-data', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], RWSToolsDetectTasksDataComponent);
RWSToolsDetectTasksDataComponent.defineComponent();
